import { render, staticRenderFns } from "./SearchIcon.vue?vue&type=template&id=907cf7ec&scoped=true&"
var script = {}
import style0 from "./SearchIcon.vue?vue&type=style&index=0&id=907cf7ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "907cf7ec",
  null
  
)

export default component.exports